// Added 2026-10-07, fixing a real reported bug: the bell's unread count
// (Header.js) and the full notifications page (Notifications.js) are
// separate component instances with no shared state -- each polls/
// fetches independently. Marking something read on the notifications
// page updated that page's own local list, but the bell had no way to
// know anything changed until its own next 15s poll tick, so it kept
// showing a stale count right after "Mark all as read" was clicked.
//
// This is a minimal browser-native pub/sub (a plain window CustomEvent)
// rather than lifting unreadCount into shared state/context -- anything
// that marks a notification read dispatches NOTIFICATIONS_READ_EVENT;
// Header.js listens for it and re-fetches its count immediately, on top
// of its normal poll.
export const NOTIFICATIONS_READ_EVENT = "notifications-read-updated";

export const notifyNotificationsRead = () => {
  window.dispatchEvent(new Event(NOTIFICATIONS_READ_EVENT));
};
